import React, { useState } from "react";
import { householdApi } from "../services/api";
import "./HouseholdSetup.css";

export default function HouseholdSetup({ onJoined }) {
  const [mode, setMode] = useState(null); // "create" or "join"
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [chatIds, setChatIds] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const ids = chatIds.split(",").map((s) => s.trim()).filter(Boolean);
      const household = await householdApi.create({ name, telegram_chat_ids: ids });
      localStorage.setItem("household_id", household.id);
      localStorage.setItem("household_name", household.name);
      localStorage.setItem("household_code", household.invite_code);
      onJoined(household);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to create household.");
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const household = await householdApi.join(code.trim().toUpperCase());
      localStorage.setItem("household_id", household.id);
      localStorage.setItem("household_name", household.name);
      localStorage.setItem("household_code", household.invite_code);
      onJoined(household);
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid invite code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="setup-container">
      <div className="setup-card">
        <div className="setup-logo">🏠</div>
        <h1 className="setup-title">HomeStock</h1>
        <p className="setup-sub">Create a household or join an existing one</p>

        {error && <div className="setup-error">{error}</div>}

        {!mode && (
          <div className="setup-buttons">
            <button className="btn-setup-primary" onClick={() => setMode("create")}>
              🏡 Create New Household
            </button>
            <button className="btn-setup-secondary" onClick={() => setMode("join")}>
              🔑 Join with Invite Code
            </button>
          </div>
        )}

        {mode === "create" && (
          <div className="setup-form">
            <div className="form-group">
              <label>Household Name</label>
              <input
                type="text"
                placeholder="e.g. My Home, Smith Family…"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>Telegram Chat IDs <span className="optional">(optional)</span></label>
              <input
                type="text"
                placeholder="123456789, 987654321"
                value={chatIds}
                onChange={(e) => setChatIds(e.target.value)}
              />
              <p className="field-hint">Separate multiple IDs with commas</p>
            </div>
            <div className="setup-form-actions">
              <button className="btn-ghost" onClick={() => setMode(null)}>Back</button>
              <button className="btn-setup-primary" onClick={handleCreate} disabled={loading || !name.trim()}>
                {loading ? "Creating…" : "Create Household"}
              </button>
            </div>
          </div>
        )}

        {mode === "join" && (
          <div className="setup-form">
            <div className="form-group">
              <label>Invite Code</label>
              <input
                type="text"
                placeholder="e.g. HOME42"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                maxLength={6}
                autoFocus
                className="code-input"
              />
            </div>
            <div className="setup-form-actions">
              <button className="btn-ghost" onClick={() => setMode(null)}>Back</button>
              <button className="btn-setup-primary" onClick={handleJoin} disabled={loading || !code.trim()}>
                {loading ? "Joining…" : "Join Household"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
